import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { RastreoComponent } from './rastreo/rastreo.component';
import { LoginComponent } from './login/login.component';
import { UnidadesComponent } from './unidades/unidades.component';
import { GeocercasComponent } from './geocercas/geocercas.component';
import { OperadoresComponent } from './operadores/operadores.component';
import { UsuariosComponent } from './usuarios/usuarios.component';
import { ForgetpassgordComponent } from './forgetpassgord/forgetpassgord.component';
import { Error404Component } from './error404/error404.component';

import { AuthGuard } from './auth.guard';

/**
 * Rutas para movernos dentro de las vistas
**/
const routes: Routes = [
  { path: '', component: RastreoComponent, canActivate: [AuthGuard] },
  { path: 'login', component: LoginComponent},
  { path: 'unidades', component: UnidadesComponent},
  { path: 'geocercas', component: GeocercasComponent},
  { path: 'operadores', component: OperadoresComponent},
  { path: 'usuarios', component: UsuariosComponent},
  { path: 'restablecer-contrasena/:token', component: ForgetpassgordComponent},
  // otherwise redirect to home
  { path: '**', component: Error404Component}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
